import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { LOGGED_HOME_PAGE_PATH } from "../../../../constants/env";
import { useIsLogged } from "../../../../hooks/auth/use-is-logged/use-is-logged";

interface AnonymousOnlyGuardProps {
  readonly children: ReactNode;
}

export function AnonymousOnlyGuard(props: AnonymousOnlyGuardProps): JSX.Element {
  const { children } = props;
  const isLogged = useIsLogged();

  if (isLogged) {
    return <Navigate to={LOGGED_HOME_PAGE_PATH} replace />;
  }

  return <>{children}</>;
}
